export enum XpTransactionType {
  REFILL = 'refill',
  REDEEM = 'redeem',
}

export enum XpTransactionScope {
  LISTING_PUBLISH = 'listing-publish',
  DEAL_CONFIRMED = 'deal-confirmed',
  BUY_CAR = 'buy-car',
  SELL_CAR = 'sell-car',
  MANUAL = 'manual',
}

export interface XpAccount {
  walletId: string;
  balance: number;
  createdAt: string;
  updatedAt: string | null;
}

export interface XpTransaction {
  id: string;
  walletId: string;
  amount: number;
  type: XpTransactionType;
  scope: XpTransactionScope | null;
  metadata: Record<string, any> | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface XpTransactionFull extends XpTransaction {
  xpAccount: XpAccount;
  wallet: {
    id: string;
    address: string;
  };
}

export interface XpAccountBalance extends XpAccount {
  transactions: XpTransaction[];
}

export interface XpTransactionList {
  total: number;
  limit: number;
  offset: number;
  items: XpTransactionFull[];
}

export interface XpTransactionListParams {
  limit?: number;
  offset?: number;
  type?: XpTransactionType;
  scope?: XpTransactionScope | null;
  sortField?: string;
  sortDirection?: 'ASC' | 'DESC';
}
